<template>
  <main>
    <v-tabs v-model="tab" show-arrows centered>
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">Profile</v-tab>
      <v-tab href="#tab-2">Change Email</v-tab>
      <v-tab href="#tab-3" v-if="showPassword === true">Password</v-tab>
      <v-tab href="#tab-4" v-if="showTicketingLink === true">Link Fan-ID</v-tab>
      <v-tab href="#tab-5" v-if="showContactPrefs === true">Preferences</v-tab>
      <!--<v-tab href="#tab-5" >Membership &amp; Loyalty</v-tab>-->
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1" :key="1">
        <div v-if="showProfilePicture === true">
          <UserProfileImage />
        </div>
        <UserProfileFull />
      </v-tab-item>

      <v-tab-item v-if="showPassword === true" value="tab-2" :key="2">
        <UserProfileChangeEmail />
      </v-tab-item>

      <v-tab-item v-if="showPassword === true" value="tab-3" :key="3">
        <UserProfilePassword />
      </v-tab-item>

      <v-tab-item v-if="showTicketingLink === true" value="tab-4" :key="4">
        <UserProfileSeatgeekLink />
      </v-tab-item>

      <v-tab-item v-if="showContactPrefs === true" value="tab-5" :key="5">
        <UserProfileContactPrefs />
      </v-tab-item>

      <!--<v-tab-item :value="'tab-5'" :key="5">
        <UserProfileMembership />
        <UserProfileClientRefNo />
      </v-tab-item>-->
    </v-tabs-items>

    <FooterShout :type="'help'" />
  </main>
</template>

<script>
import UserProfileFull from "@/components/UserProfileFull";
import UserProfilePassword from "@/components/UserProfilePassword";
import UserProfileChangeEmail from "@/components/UserProfileChangeEmail";
// import UserProfileClientRefNo from '@/components/UserProfileClientRefNo'
import UserProfileImage from "@/components/UserProfileImage";
import UserProfileSeatgeekLink from "@/components/UserProfileSeatgeekLink";
import UserProfileContactPrefs from "@/components/UserProfileContactPrefs";
// import UserProfileMembership from '@/components/UserProfileMembership'
import FooterShout from "@/components/FooterShout";

export default {
  components: {
    UserProfileFull,
    UserProfileChangeEmail,
    UserProfilePassword,
    // UserProfileClientRefNo,
    UserProfileImage,
    UserProfileSeatgeekLink,
    UserProfileContactPrefs,
    // UserProfileMembership,

    FooterShout,
  },
  data() {
    return {
      showPassword: false,
      showMembership: false,
      showProfilePicture: false,
      showTicketingLink: false,
      showContactPrefs: false,
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      age: null,
      tab: "tab-1", // default tab
    };
  },
  mounted() {
    if (this.$getAuthenticatedUser() == null) {
      this.$router.push("/");
    } else {
      // check to see if the user was created with traditional registration (and not Facebook or Google)
      this.$getCurrentUserAttributes().subscribe((userData) => {
        if (userData.email_verified) {
          this.showPassword = true; //if they did register with their email, then let them change password
        }
        // Allow ticketing link tab to be seen if user is from approved organisation
        this.showTicketingLink = false; // Removed 9 Jul 25 (https://urbanzoo.atlassian.net/browse/UZ-2100)
        if (new URL(document.URL).hash == "#link") {
          this.tab = "tab-4";
        }

        if (userData.birthdate) {
          var birthdayDates = userData.birthdate.split("-");
          this.dobDay = parseInt(birthdayDates[2]);
          this.dobMonth = parseInt(birthdayDates[1]);
          this.dobYear = parseInt(birthdayDates[0]);
          this.checkAge();
          if (this.age < this.configValues.accountConsentAge) {
            // if they are below the consent age then don;t allow marketing
            this.showContactPrefs = false;
          } else {
            this.showContactPrefs = true;
          }
        }
      });
    }
  },
  methods: {
    checkAge() {
      this.age = null;
      this.age = this.calculateAge(this.dobYear, this.dobMonth, this.dobDay);
    },
  },
};
</script>
<style scoped>
.theme--light.v-tabs__bar .v-tabs__div {
  color: #73a2dc;
}
</style>
